import React from 'react';
import { Type } from '../../../../../general/modules/filter/dataModel';

import { FileManagerRow, FMColumn } from '../../model';

import './styles.scss';

export const IntroCellInner: React.FC<{
  rowData: FileManagerRow;
  column: FMColumn<Type.ID>;
}> = ({ rowData }) => {
  const introRaw = rowData.creative?.intro;

  if (!introRaw) {
    return <span></span>;
  }

  return <span title={introRaw.name}>{introRaw.name}</span>;
};
